import React from 'react'
import { withTranslation } from 'react-i18next'
import { ArrowCircleRight } from 'phosphor-react'
import PropTypes from 'prop-types'
import { CardFooter, Col, Card, CardImg } from 'reactstrap'
import Skeleton from '../UI/Skeleton'

class AuthorCard extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            link: `/author/${this.props.id}`,
            // eslint-disable-next-line no-undef
            imageUrl: process.env.REACT_APP_IMAGEURL,
        }
        this.routeToAuthor = this.routeToAuthor.bind(this)
    }

    routeToAuthor() {
        this.props.props.history.push(this.state.link)
    }

    render() {
        const { t } = this.props
        return (
            <Col lg={6} xl={4} sm={12} md={6} className="custom-card author-card d-flex align-items-stretch">
                {
                    this.props.skeleton ?
                        <Card className="d-flex flex-column">
                            <Skeleton className="custom-card-img mt-0" height={320} />
                            <div className="custom-card-title md-font-size" >
                                <Skeleton />
                            </div>
                            <div className="custom-card-desc md-font-size" >
                                <Skeleton count={3} />
                            </div>
                            <CardFooter className="mt-auto">
                                <div className="custom-card-whitespace"></div>
                                <Skeleton height={44} />
                            </CardFooter>
                        </Card>
                        :
                        <Card className="d-flex flex-column">
                            <CardImg src={this.props.image ? `${this.state.imageUrl}/${this.props.image}` : "data:,"} alt="" className="custom-card-img mt-0" onClick={this.routeToAuthor} />
                            <div className="card-langs">{this.props.langs.map((lang, index) => (
                                <div className="card-lang" key={`${lang.lang}-${index}`}>
                                    <span className={`flag-icon flag-icon-${lang.code}`}></span>
                                    <span className="text xs-font-size">{lang.lang}</span>
                                </div>
                            ))}</div>
                            <div className="custom-card-title md-font-size">{this.props.title}</div>
                            <div className="custom-card-desc md-font-size" dangerouslySetInnerHTML={{ __html: this.props.desc }}></div>
                            <CardFooter className="mt-auto">
                                <div className="custom-card-whitespace"></div>
                                <div className="custom-card-btn primary btn btn-secondary plr-20px" onClick={this.routeToAuthor}>
                                    <div className="news-btn-content">
                                        <ArrowCircleRight size={20} color="#FFFFFF" />
                                        <span className="custom-btn-desc sm-font-size">{t('news-read-more')}</span>
                                    </div>
                                </div>
                            </CardFooter>
                        </Card>
                }
            </Col>
        )
    }
}

AuthorCard.propTypes = {
    id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    t: PropTypes.func,
    desc: PropTypes.string,
    title: PropTypes.string,
    props: PropTypes.object,
    image: PropTypes.string,
    langs: PropTypes.array,
    skeleton: PropTypes.bool,
}

export default withTranslation()(AuthorCard)



// WEBPACK FOOTER //
// ./src/components/Authors/AuthorCard.jsx